
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  margin-left: 1rem;
  margin-right: 1rem;
  flex-grow: 1;
  mix-blend-mode:multiply;
}

.tab {
  pointer-events: auto;
  border-width: 1px;
  border-style: solid;
  border-color: var(--blue-responsible-darken-2);
  margin-bottom: 0px;
  border-radius: 9999px;
  padding: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: center;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  color: var(--blue-responsible-darken-2);
  background-image:none !important;
  word-wrap:break-word;
}

.tab.tab--active {
  background-color: var(--blue-responsible-darken-2);
}

.tab--active {
  background-color: var(--blue-responsible-darken-2) !important;
  font-weight: var(--fw-semibold) !important;
  color: var(--outline-white) !important;
}

.tab:hover:not(.tab--disabled) {
  background-color: var(--blue-responsible-lighten-5) !important;
  color: var(--blue-responsible-darken-1) !important;
}

.tab:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.tab:focus:not(.tab--disabled), .tab:focus-visible:not(.tab--disabled) {
  background-color: var(--blue-responsible-lighten-5) !important;
  color: var(--blue-responsible-darken-1) !important;
}

:host([tab-style='stats']) {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.style--stats.tab {
  border-width: 0px;
}

.style--stats.tab {
  background-color: var(--gray-professional-lighten-2);
}

.style--stats.tab {
  color: var(--neutral-white);
}

.style--stats.tab {
  border-radius: 0.25rem;
}

.style--stats.tab {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.style--stats.tab {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.style--stats.tab.tab--active, .style--stats.tab:hover:not(.tab--disabled), .style--stats.tab:focus:not(.tab--disabled), .style--stats.tab:focus-visible:not(.tab--disabled) {
  background-color: var(--cyan-near-main) !important;
}

.style--stats.tab.tab--active, .style--stats.tab:hover:not(.tab--disabled), .style--stats.tab:focus:not(.tab--disabled), .style--stats.tab:focus-visible:not(.tab--disabled) {
  font-weight: var(--fw-normal) !important;
}

.style--stats.tab.tab--active, .style--stats.tab:hover:not(.tab--disabled), .style--stats.tab:focus:not(.tab--disabled), .style--stats.tab:focus-visible:not(.tab--disabled) {
  color: var(--neutral-white) !important;
}

:host([tab-width='short']) .tab {
  min-width: 12rem;
}

:host([tab-width='short']) .tab {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

:host([tab-style='numbered']) {
  margin-left: 4.5rem;
  margin-right: 0px;
  margin-bottom: 0.125rem;
  mix-blend-mode:unset;
}

.style--numbered.tab {
  position: relative;
}

.style--numbered.tab {
  display: flex;
}

.style--numbered.tab {
  height: 100%;
}

.style--numbered.tab {
  flex-direction: column;
}

.style--numbered.tab {
  justify-content: center;
}

.style--numbered.tab {
  white-space: normal;
}

.style--numbered.tab {
  border-radius: 0px;
}

.style--numbered.tab {
  border-width: 0px;
}

.style--numbered.tab {
  border-bottom-width: 4px;
}

.style--numbered.tab {
  border-style: solid;
}

.style--numbered.tab {
  border-color: var(--gray-professional-lighten-3);
}

.style--numbered.tab {
  text-align: left;
}

.style--numbered.tab {
  color: var(--gray-professional-lighten-1);
}

.style--numbered.tab ::slotted(.index) {
  position: absolute;
}

.style--numbered.tab ::slotted(.index) {
  top: 50%;
}

.style--numbered.tab ::slotted(.index) {
  left: -4rem;
}

.style--numbered.tab ::slotted(.index) {
  display: flex;
}

.style--numbered.tab ::slotted(.index) {
  height: 3.75rem;
}

.style--numbered.tab ::slotted(.index) {
  width: 3.75rem;
}

.style--numbered.tab ::slotted(.index) {
  align-items: center;
}

.style--numbered.tab ::slotted(.index) {
  justify-content: center;
}

.style--numbered.tab ::slotted(.index) {
  border-radius: 9999px;
}

.style--numbered.tab ::slotted(.index) {
  background-color: var(--gray-professional-lighten-3);
}

.style--numbered.tab ::slotted(.index) {
  padding: 0px;
}

.style--numbered.tab ::slotted(.index) {
  font-size: var(--fs-2xl);
  line-height: var(--lh-2xl);
}

.style--numbered.tab ::slotted(.index) {
  font-weight: var(--fw-bold);
}

.style--numbered.tab ::slotted(.index){
      transform:translateY(-50%);
    }

.style--numbered.tab.tab--active, .style--numbered.tab:hover:not(.tab--disabled), .style--numbered.tab:focus:not(.tab--disabled), .style--numbered.tab:focus-visible:not(.tab--disabled) {
  border-color: var(--blue-responsible-lighten-6) !important;
}

.style--numbered.tab.tab--active, .style--numbered.tab:hover:not(.tab--disabled), .style--numbered.tab:focus:not(.tab--disabled), .style--numbered.tab:focus-visible:not(.tab--disabled) {
  background-color: var(--cyan-near-lighten-4) !important;
}

.style--numbered.tab.tab--active, .style--numbered.tab:hover:not(.tab--disabled), .style--numbered.tab:focus:not(.tab--disabled), .style--numbered.tab:focus-visible:not(.tab--disabled) {
  font-weight: var(--fw-bold) !important;
}

.style--numbered.tab.tab--active, .style--numbered.tab:hover:not(.tab--disabled), .style--numbered.tab:focus:not(.tab--disabled), .style--numbered.tab:focus-visible:not(.tab--disabled) {
  color: var(--blue-responsible-lighten-6) !important;
}

.style--numbered.tab.tab--active ::slotted(.index), .style--numbered.tab:hover:not(.tab--disabled) ::slotted(.index), .style--numbered.tab:focus:not(.tab--disabled) ::slotted(.index), .style--numbered.tab:focus-visible:not(.tab--disabled) ::slotted(.index) {
  background-color: var(--blue-responsible-lighten-6);
}

.style--numbered.tab.tab--active ::slotted(.index), .style--numbered.tab:hover:not(.tab--disabled) ::slotted(.index), .style--numbered.tab:focus:not(.tab--disabled) ::slotted(.index), .style--numbered.tab:focus-visible:not(.tab--disabled) ::slotted(.index) {
  color: var(--neutral-white);
}


`;